



































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import HotkeyListener from '@/layouts/gripper/hotkeys/HotkeyListener.vue';

@Component({
  components: {HotkeyListener},
})
export default class PaginateButtons extends Vue {

  @Prop({default: true}) public canChangePage?: boolean;
  @Prop(Number) public currentPage!: number;
  @Prop(Number) public totalPages!: number;

  private pageNumberAmount: number = 2;
  private pageSelection: number = this.currentPage;

  public pageChange(origin: KeyboardEvent['key'] | string | number) {
    if (origin === 'previous' || origin === 'PageDown' && this.currentPage > 1) {
      this.$emit('onPageChangeEvent', this.currentPage - 1);
    } else if (origin === 'next' || origin === 'PageUp') {
      this.$emit('onPageChangeEvent', this.currentPage + 1);
    } else if (typeof origin === 'number') {
      this.$emit('onPageChangeEvent', origin);
    }
  }

  @Watch('currentPage')
  private function() {
    this.pageSelection = this.currentPage;
  }
}
